import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// DO NOT EDIT IT MANUALLY

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgUsers = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  props.width = undefined;
  props.height = undefined;
  var testId = 'icon-users';
  var style = {};
  var isCustomSize = typeof size === 'number';
  if (isCustomSize) {
    style.width = size + 'px';
    style.height = size + 'px';
    if (!props.style) props.style = {};
    props.style.width = size + 'px';
    props.style.height = size + 'px';
  }
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "data-test-id": testId,
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fill: "inherit",
      fillRule: "evenodd",
      d: "M16.11 4.284c-.786.081-1.563.511-2.11 1.166-.27.324-.568.886-.661 1.25a4 4 0 0 0-.003 1.82 3.37 3.37 0 0 0 1.722 2.119c.572.281.817.338 1.442.338s.87-.057 1.442-.338a3.4 3.4 0 0 0 1.645-1.856c.299-.841.22-1.97-.191-2.741-.655-1.23-1.909-1.9-3.286-1.758m1.12 1.638c1.153.566 1.4 2.137.481 3.054-.705.702-1.717.702-2.422 0-.868-.866-.703-2.352.33-2.973.325-.195.537-.245.971-.228.321.012.405.031.64.147M7.11 7.284c-.786.081-1.563.511-2.11 1.166-.27.324-.568.886-.661 1.25a4 4 0 0 0-.003 1.82 3.37 3.37 0 0 0 1.722 2.119c.572.281.817.338 1.442.338s.87-.057 1.442-.338a3.4 3.4 0 0 0 1.645-1.856c.299-.841.22-1.97-.191-2.741-.655-1.23-1.909-1.9-3.286-1.758m1.12 1.638c1.153.566 1.4 2.137.481 3.054-.705.702-1.717.702-2.422 0-.868-.866-.703-2.352.33-2.973.325-.195.537-.245.971-.228.321.012.405.031.64.147m4.07 3.808c-.053.115-.284.63-.515 1.143l-.419.932.167.073c.092.04.391.174.664.298.273.123.509.224.525.224s.169-.315.34-.7l.311-.7 3.14.01 3.139.01.827 1.63c.455.896.838 1.64.85 1.652.035.035 1.311-.616 1.311-.669 0-.025-.463-.961-1.029-2.079l-1.029-2.034h-8.186zm-9.93 4.861-1.047 2.071.663.331c.365.182.673.321.686.309.012-.013.394-.756.848-1.652l.827-1.63h6.305l.827 1.63c.455.896.838 1.64.85 1.652.035.035 1.311-.616 1.311-.669 0-.025-.463-.961-1.029-2.079l-1.029-2.034H3.417z"
    })
  }));
});
export default SvgUsers;